<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">

      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
        <v-form ref="formAutomation">
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 text-xs-center>
              <h1>Автоматизация</h1>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-select
                v-model="selectedCompany"
                :items="availableCompanies"
                @change="changeSetup"
                item-text="name"
                item-value="id"
                label="Компания"
                required>
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-switch
                color="#4169E1"
                v-model="selectedSetup.hasScheduledJob"
                label="Автоматизация"
              ></v-switch>
            </v-flex>
            <template v-if="selectedSetup.hasScheduledJob">
              <v-flex v-if="selectedSetup.hasScheduledJob" xs12 sm10 md8 lg7>
                <v-select
                  v-model="selectedSetup.type"
                  :items="types"
                  label="Тип"
                  required>
                </v-select>
              </v-flex>
              <v-flex xs12 sm10 md8 lg7>
                <v-select
                  v-model="selectedSetup.time"
                  :items="times"
                  label="Время"
                  required>
                </v-select>
              </v-flex>
              <v-flex xs12 sm10 md8 lg7>
                <v-switch
                  color="#4169E1"
                  v-model="selectedSetup.autoSms"
                  label="Автоматические СМС"
                ></v-switch>
              </v-flex>
            </template>
            <v-flex xs12 text-xs-center>
              <v-btn color="#4169E1" style="color:white" @click="update()">Сохранить</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    availableSetups: {},
    selectedSetup: {},
    availableCompanies: [],
    selectedCompany: '',
    errorMessage: '',
    types: ['сегодня', 'завтра'],
    times: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00',
      '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00',
      '21:00', '22:00', '23:00'],
    init: false
  }),

  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },

  methods: {
    getInfo: function () {
      this.$http.get('/api/setupAutomation/getInfo')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            response.data.forEach(item => {
              this.availableCompanies.push({
                id: item.companyId,
                name: item.companyName
              })
              item.type = item.schedulePeriod === 0 ? 'сегодня' : 'завтра'
              if (item.scheduleTime !== undefined) {
                item.time = item.scheduleTime + ':00'
                if (item.time.length === 4) {
                  item.time = '0' + item.time
                }
              } else {
                item.time = '10:00'
              }
              this.availableSetups[item.companyId] = item
              if (item.isDefault === true) {
                this.selectedSetup = item
              }
            })
            if (this.selectedSetup.companyId === undefined) {
              this.selectedSetup = response.data[0]
            }
            this.selectedCompany = this.selectedSetup.companyId
          }
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    update: function () {
      this.$http.post('/api/setupAutomation/update', this.selectedSetup)
        .then(response => {
          this.$store.dispatch('showSnackbar', {
            text: 'Настройки автоматизации обновлены',
            color: 'success'
          })
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    changeSetup: function (selectedId) {
      this.selectedSetup = this.availableSetups[selectedId]
    }
  }
}
</script>
